import * as React from "react";
import { handleEvent } from "../../core/utils/handleEvents";
import { IButtonEvents } from "../_common/buttonEvents";
import { Wrapper } from "./components/Wrapper";

export interface IBaseButton extends IButtonEvents {
  children?: any;
  onClick?: any;
  disabled?: boolean;
  active?: boolean;
  className?: string;
  role?: string;
  primary?: boolean;
}

export const BaseButton = ({ children, ...props }: IBaseButton) => (
  <Wrapper
    {...props}
    onDragStart={props.onDragStart}
    data-api-name={props.apiName}
    onClick={handleEvent(props.onClick)}
    onMouseEnter={handleEvent(props.onMouseEnter)}
    onMouseLeave={handleEvent(props.onMouseLeave)}
    onMouseDown={handleEvent(props.onMouseDown)}
    onMouseUp={handleEvent(props.onMouseUp)}
    onTouchStart={handleEvent(props.onTouchStart)}
    onTouchEnd={handleEvent(props.onTouchEnd)}
    role="button"
  >
    {children}
  </Wrapper>
);
